const faculty = [
  { name: "Dr. Anil Verma", role: "Senior Biomedical Engineer · ex-GE Healthcare", img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&q=80" },
  { name: "Sneha Iyer", role: "Clinical Application Specialist · Philips", img: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=800&q=80" },
  { name: "Rohit Sharma", role: "Service Engineer · Siemens Healthineers", img: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=80" },
  { name: "Dr. Priya Menon", role: "HOD Biomedical · Apollo Hospitals", img: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=80" },
  { name: "Karan Patel", role: "Founder · BIOMAC · 12y industry exp", img: "https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=800&q=80" },
  { name: "Aarti Nair", role: "Career Coach & Mock-Interviewer", img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800&q=80" },
];

export const Faculty = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="faculty-page">
    <span className="eyebrow">Industry Faculty</span>
    <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-semibold text-[#0A3B32] tracking-tight max-w-4xl">
      Learn from people who've done the job — not just taught it.
    </h1>
    <p className="mt-5 text-lg text-slate-600 max-w-2xl">
      Every BIOMAC trainer has 8+ years of hands-on experience with India's top medical
      device companies and hospitals.
    </p>

    <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {faculty.map((f, i) => (
        <div key={f.name} className="card-soft" data-testid={`faculty-${i}`}>
          <img
            src={f.img}
            alt={f.name}
            className="w-full h-64 object-cover rounded-xl"
          />
          <h3 className="mt-5 font-heading text-xl font-semibold text-[#0A3B32]">{f.name}</h3>
          <p className="mt-1 text-sm text-slate-500">{f.role}</p>
        </div>
      ))}
    </div>
  </div>
);
